import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { BaseComponent } from 'src/app/base/components/base.component';

@Component({
  selector: 'app-thumbnail-files-list',
  templateUrl: './thumbnail-files-list.component.html',
  styleUrls: ['./thumbnail-files-list.component.scss']
})
export class ThumbnailFilesListComponent extends BaseFormComponent<any> implements OnInit {
  @Input() listFiles:any = [];
  @Input() title:string = 'Anexos';
  @Input() service:any = null;
  @Output() closeModal = new EventEmitter<void>();
  
  iconFileHtml:any =  this.setFilePath('file-html.svg');
  iconFilePdf:any =  this.setFilePath('file-pdf.svg');
  iconFileTxt:any =  this.setFilePath('file-txt.svg');

  constructor(
    public activatedRoute: ActivatedRoute,
    private sanitizer:DomSanitizer
  ) { 
    super(activatedRoute);
  }

  ngOnInit() {
    console.log(this.listFiles)
    this.loaded();
  }
  onCloseModal(){
    this.closeModal.emit();
  }
  getThumbnail(file){
    if(!file.thumbnail){
      switch(file.extension){
        case 'html':
          return this.setFilePath('file-html.svg');
        case 'pdf':
          return this.setFilePath('file-pdf.svg');
        case 'txt':
          return this.setFilePath('file-txt.svg');
        default:
          return null;//colocar aqui uma img que represente o vazio
      }
    }
    return this.sanitizer.bypassSecurityTrustUrl(file.thumbnail);
  }
  getSize(fileSize){
    if(fileSize>=1073741824){
      return (fileSize / 1073741824).toFixed(2) + 'Gb';
    }
    else if(fileSize>=1048576){
      return (fileSize / 1048576).toFixed(2) + 'Mb';
    }
    else {
      return (fileSize / 1024).toFixed(2) + 'Kb';
    }
  }
  
  setFilePath(filePath: string) {
    const fullPath = `assets/images/svgs/${filePath}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(fullPath);
  }

  download(id:number, fileName:string): void {
    this.loading();
    this.service.downloadFile(id,'pf').subscribe({
      next: (res) => {
        this.downloadFile(res, fileName);
      },
      error: (error) => {
        console.error('Erro ao baixar o arquivo:', error);
        this.loaded();
        this.msgError(error?.error.message);
      },
    });
  }

  downloadFile(res, fileName:string) {
    const blob = new Blob([res.body], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(url);
    this.loaded();
  }
}
